import { reactive } from 'vue'
import { getAccessToken, getStoredTenantId } from '@/services/utils/auth'

const MANUAL_LOGIN_KEY = 'collaboration-manual-login'
const manualLoginKey = () => MANUAL_LOGIN_KEY + ':' + getStoredTenantId()
export const authenticationState = reactive({
    status: 'idle' as 'idle' | 'checking' | 'refreshing' | 'loading' | 'ready' | 'error',
    token: '',
    generation: 0
})
let guard: (() => Promise<boolean>) | undefined

export function registerAuthenticationGuard(value: () => Promise<boolean>): void {
    guard = value
}

export async function waitForAuthentication(): Promise<boolean> {
    if (['ready', 'refreshing'].includes(authenticationState.status)
        && !!authenticationState.token && authenticationState.token === getAccessToken()) return true
    return guard ? guard() : true
}

export function invalidateAuthentication(): void {
    authenticationState.generation++
    authenticationState.status = 'idle'
    authenticationState.token = ''
}

export function markAuthenticationReady(): void {
    authenticationState.token = getAccessToken()
    authenticationState.status = 'ready'
}

export function pauseAutomaticLogin(): void {
    try { sessionStorage.setItem(manualLoginKey(), '1') } catch { /* Storage may be unavailable. */ }
}

export function resumeAutomaticLogin(tenantId = getStoredTenantId()): void {
    try { sessionStorage.removeItem(MANUAL_LOGIN_KEY + ':' + tenantId) } catch { /* Storage may be unavailable. */ }
}

export function isAutomaticLoginPaused(): boolean {
    try { return sessionStorage.getItem(manualLoginKey()) === '1' } catch { return false }
}
